import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import {
  Row,
  Col,
  Button,
  ButtonGroup
} from 'react-bootstrap';
import {
  MapPanelFeature,
  MapCreatorMapUpload,
  MapCreatorKMLUpload
 } from 'components';
import tokml from 'tokml';

class MapPanel extends React.Component {
  constructor(props) {
    super(props);
    this.createKML = this.createKML.bind(this);
  }

  createKML(map) {
    const kml = tokml({
      type: map.type,
      properties: {
        ...map.properties
      },
      features: map.features.filter(feature => feature.geometry.type === 'Polygon').map(
        feature => ({
          ...feature,
          properties: {
            ...feature.properties,
            'fill': feature.properties.fillColor || '#000000',
            'fill-opacity': 0.3
          }
        })
      )
    }, {
      simplestyle: true,
      documentName: map.properties.title,

    });
    const element = document.createElement('a');
    element.setAttribute('href', 'data:application/vnd.google-earth.kml+xml,' + encodeURIComponent(kml));
    element.setAttribute('download', `${map.properties.title}-${map.properties.storm_date}.kml`);
    element.setAttribute('target','_blank');
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    console.log(kml);
  }

  render() {
    const { map } = this.props;
    const { current_map, hidden_maps } = this.props.mapCreator;
    const active = map && current_map && map._id == current_map._id;
    const currentClass = active ? 'active' : '';
    const map_hidden = hidden_maps.includes(map._id);

    return (
      <li
        className={`list-group-item clearfix ${currentClass}`}
        onClick={() => this.props.setCurrentMapCreatorMap(map)}
        >
        <div className='row'>
          <div className='col-xs-12'>
            <h5>{map.properties.title}</h5>
            {active ? (
              <div>
                <h6>Map Features</h6>
                <ul className='list-unstyled clearfix mb-sm'>
                  {map.features.map((feature, idx) => (
                    <MapPanelFeature
                      map={map}
                      idx={idx}
                      feature={feature}
                      key={feature.properties._id}
                    />
                  ))}
                </ul>
                <MapCreatorMapUpload map={map}/>
                <MapCreatorKMLUpload map={map}/>
              </div>
            ) : null}
          </div>
          <div className='col-xs-12'>
            <div className='row row-edit-buttons'>
              <div className='col-xs-12 col-sm-6'>
                <div className='btn-group btn-group-xs'>
                  <div
                    onClick={() => this.props.initEditMap(map._id)}
                    className='btn btn-default'
                    >
                    <i className='fa fa-edit' />
                  </div>
                  <div
                    onClick={() => this.props.initDeleteMap(map._id)}
                    className='btn btn-danger'
                    >
                    <i className='fa fa-trash' />
                    </div>
                  <div
                    onClick={() => this.props.toggleMapHidden(map._id)}
                    className='btn btn-default'
                    >
                    <i className={map_hidden ? 'fa fa-eye-slash' : 'fa fa-eye' } />
                  </div>
                </div>
              </div>
              <div className='col-xs-12 col-sm-6'>
                <Button onClick={e => this.createKML(map)} block bsStyle='success'>
                  <i className='fa fa-arrow-down' /> KML
                </Button>
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  }
}

export default mapCreatorConnect(MapPanel);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/map-panel.js